export class Contact {
  subject: string;
  email: string = 'jeromemcnealy@hotmail.com';
  message: string;
}
